.sn-call-to-action-type-2 {
  .call-to-action-type-2__content {
    overflow: hidden;
    border: 0;
    border-radius: map-get($border-radii, lg);
    background: $color-brand-primary-darkest;
    color: $text-color-alternate;
    text-align: center;

    @include above($breakpoint-desktop-md) {
      text-align: left;
    }

    > .me-row {
      margin-right: 0;
      margin-left: 0;
    }
  }

  .call-to-action-type-2__intro {
    &-inner {
      padding: map-get($spacings, 4xl) map-get($spacings, 2xl) map-get($spacings, 2xl);

      @include above($breakpoint-desktop-md) {
        padding: map-get($spacings, 6xl) 0 map-get($spacings, 3xl) map-get($spacings, 5xl);
      }
    }
  }

  .call-to-action-type-2__media {
    display: none;

    @include above($breakpoint-desktop-md) {
      display: block;
    }

    &-inner {
      padding: map-get($spacings, 4xl) map-get($spacings, 4xl) map-get($spacings, 4xl) 0;
    }

    .picture {
      background-color: transparent;
    }
  }

  .me-text--label {
    display: block;
    margin-bottom: map-get($spacings, md);
    text-transform: uppercase;
    letter-spacing: 3px;
    font-size: map-get($font-sizes, xs);
    font-weight: map-get($font-weights, bold);
  }

  .me-button {
    min-width: 214px;

    @include above($breakpoint-desktop-md) {
      min-width: 199px;
    }
  }

  // Desktop: use a real flex gap so spacing survives when the two buttons wrap
  // onto separate lines (the intro column is only half-width, so at ~960–1100px
  // they stack). The me-row y-gap uses margin-bottom, which we'd have to zero here
  // to avoid a stray gap when side-by-side — but that also kills the gap when they
  // wrap. `gap` covers both directions regardless of wrap. x-gap padding/margins are
  // neutralized so horizontal spacing isn't doubled.
  @include desktop-lg {
    .call-to-action-type-2__actions.me-row {
      display: flex;
      flex-wrap: wrap;
      gap: var(--spacing-md);
      margin-left: 0;
      margin-right: 0;

      > .me-column {
        padding: 0;
        margin-bottom: 0;

        .me-button {
          width: auto;
        }
      }
    }
  }

  // Tablet (768px–960px): override grid → flex, buttons in one row, centered
  @include between($breakpoint-desktop, $breakpoint-desktop-md - 1px) {
    .call-to-action-type-2__actions.me-row {
      display: flex;
      justify-content: center;
      width: auto;
      margin-left: 0;
      margin-right: 0;
      gap: var(--spacing-md);

      > .me-column {
        padding: 0;

        .me-button {
          width: auto;
        }
      }
    }
  }

  // Mobile: center buttons, remove bottom margin on intro column
  @include below-desktop {
    .call-to-action-type-2__actions.me-row {
      margin-left: auto;
      margin-right: auto;
    }

    .call-to-action-type-2__intro.me-column {
      margin-bottom: 0;
    }
  }
}

